import Http from "@/utils/request.js";

//开通电子钱包
export function EWalletOpen(data){
	return Http.request({
		url: `/user/sdAuth/userAuthEwallet`,
		method: 'post',
		data
	})
}
// 发送开通电子钱包短信
export function EWalletSMS(phone){
	return Http.request({
		url: `/user/sdAuth/sdSendSms`,
		method: 'post',
		data:{
			phone
		}
	})
}

//余额信息
export function WalletBalance(){
	return Http.request({
		url: `/user/profit/money`,
		method: 'post'
	})
}

//钱包记录
export function WalletRecords(data){
	return Http.request({
		url: `/user/profit/details`,
		method: 'post',
		data
	})
}

//钱包记录统计 
export function WalletRecordsStatistics(data){
	return Http.request({
		url: `/user/profit/detailsTotal`,
		method: 'post',
		data
	})
}

//钱包记录类型 
export function WalletRecordsType(type){
	return Http.request({
		url: `/user/profit/handleType`,
		method: 'post',
		data:{
			type
		}
	})
}

//提现列表 
export function WithdrawalList(data){
	return Http.request({
		url: `/user/profit/withdrawalList`,
		method: 'post',
		data
	})
}

//提现详情
export function WithdrawalDetails(serialCode){
	return Http.request({
		url: `/user/profit/withdrawalDetail`,
		method: 'post',
		data: {
			serialCode
		}
	})
}

//银行卡提现
export function BankCardWithdrawalApply(data){
	return Http.request({
		url: `/user/profit/applyWithdrawalBank`,
		method: 'post',
		data
	})
}

//转账
export function TransferAccounts(data){
	return Http.request({
		url: `/user/profit/handleChange`,
		method: 'post',
		data
	})
}

//银行卡管理
//银行卡列表
export function BankCardList(id){
	return Http.request({
		url: `/user/userCenter/userBankCardList`,
		method: 'post',
		data: {
			id
		},
		headers: {
			'Authorization': `Bearer ${uni.getStorageSync('token')}`,
			'channel': 'USER',
			'device': 'H5',
			'version': '1.0.0',
			'Content-Type': 'application/json'
		}
	})
}

//银行卡移除
export function BankCardRemove(id){
	return Http.request({
		url: `/user/userCenter/removeBindingBankCard`,
		method: 'post',
		data:{
			id
		}
	})
}

//银行卡添加
export function BankCardAdd(data){
	return Http.request({
		url: `/user/userCenter/usersBindingBankCard`,
		method: 'post',
		data
	})
}

//银行卡详情
// export function BankCardDetail(id){
// 	return Http.request({
// 		url: `/user/userCenter/userBankCardDetail`,
// 		method: 'post',
// 		data:{
// 			id
// 		}
// 	})
// }

//银行卡更新
export function BankCardUpdate(data){
	return Http.request({
		url: `/user/userCenter/updateBindingBankCard`,
		method: 'post',
		data
	})
}

//银行卡类型  
export function BankList(){
	return Http.request({
		url: `/user/base/bankType`,
		method: 'post'
	})
}

// 充值转账信息
export function TopUpInfo(){
	return Http.request({
		url: `/user/profit/getRechargeInfo`,
		method: 'post'
	})
}

// 充值记录
export function TopUpRecords(data){
	return Http.request({
		url: `/user/profit/getRechargeLog`,
		method: 'post',
		data
	})
}

// 充值提交
export function TopUpSubmit(data){
	return Http.request({
		url: `/user/profit/handleRecharge`,
		method: 'post',
		data
	})
}

// 充值上传凭证
export function TopUpUploadVoucher(data){
	return Http.request({
		url: `/user/profit/uploadRecharge`,
		method: 'post',
		data
	})
}

// 充值取消 
export function TopUpCancel(id){
	return Http.request({
		url: `/user/profit/cancelRecharge`,
		method: 'post',
		data:{
			id
		}
	})
}

// 加密货币充值记录
export function CryptoRechargeList(data){
	return Http.request({
		url: `/user/recharge/page`,
		method: 'post',
		data
	})
}

// 提交加密货币充值申请
export function CryptoRechargeSubmit(data){
	return Http.request({
		url: `/user/recharge/submitRecharge`,
		method: 'post',
		data
	})
}

// 提交加密货币提现申请
export function CryptoWithdrawSubmit(data){
	return Http.request({
		url: `/user/walletWithdraw/submitWithdraw`,
		method: 'post',
		data
	})
}

// 加密货币提现记录
export function CryptoWithdrawList(data){
	return Http.request({
		url: `/user/walletWithdraw/page`,
		method: 'post',
		data
	})
}

// 转换
export function TransferCurrency(data){
	return Http.request({
		url: `/user/profit/handleTrans`,
		method: 'post',
		data
	})
}

// 钱包地址（提款地址）管理
// 列表
export function MemberWalletAddressList(){
	return Http.request({
		url: `/user/memberWalletAddress/list`,
		method: 'post',
		data: {}
	})
}

// 新增 / 修改
export function MemberWalletAddressSaveOrUpdate(data){
	return Http.request({
		url: `/user/memberWalletAddress/saveOrUpdate`,
		method: 'post',
		data
	})
}

// 删除
export function MemberWalletAddressDelete(id){
	return Http.request({
		url: `/user/memberWalletAddress/delete`,
		method: 'post',
		data: { id }
	})
}

